import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';

import { FormTemplateComponent } from '../../core/component/form-template/form-template.component';
import { AppState } from '../../../store/app-state';

@Component({
  selector: 'app-commerce-general-template',
  templateUrl: './commerce-general-template.component.html',
  styleUrls: ['./commerce-general-template.component.scss']
})
export class CommerceGeneralTemplateComponent extends FormTemplateComponent implements OnInit {

  ownerList$
  addressTimeList$;

  constructor(private store: Store<AppState>) {
    super();
    this.ownerList$ = this.store.select(state => state.list.owner)
    this.addressTimeList$ = this.store.select(state => state.list.addressTime)
  }

  ngOnInit() {
    this.init();
  }

  template() {
    this.form.addControl('commerce', new FormControl(null));
    this.form.addControl('addressTime', new FormControl(0));
    this.form.addControl('ownerLessor', new FormControl(0));
    this.form.addControl('contact', new FormControl(null));
  }

}



// WEBPACK FOOTER //
// ./src/app/form/template/commerce-general-template/commerce-general-template.component.ts